import {
  FORMATION_GAME_SIZE_LABELS,
  FORMATION_LIMITS,
  type FormationGameSize,
  type FormationPosition,
  type TrainingFormationDto,
} from '@ukinfo/shared';

/**
 * Hilfen fuer die Formationen: Anzeigetexte und Rechnen mit Positionen.
 * Alles ohne React, damit es sich einzeln pruefen laesst.
 */

/** Ein Feldpunkt (Prozent des ganzen Feldes), auf ganze Zahlen im erlaubten Bereich gebracht. */
export function clampPosition(value: number): number {
  return Math.min(FORMATION_LIMITS.coordinateMax, Math.max(FORMATION_LIMITS.coordinateMin, Math.round(value)));
}

/** "11er", "9er" ... */
export const gameSizeLabel = (size: FormationGameSize): string => FORMATION_GAME_SIZE_LABELS[size];

/** Kurzbeschreibung fuer Listen: "11er · 11 Spieler". */
export function formationMeta(formation: Pick<TrainingFormationDto, 'gameSize' | 'positions'>): string {
  return `${gameSizeLabel(formation.gameSize)} · ${formation.positions.length} Spieler`;
}

/** Hoehe des ganzen Feldes in Zeichnungseinheiten bei Breite 100 (105 m zu 68 m). */
const FULL_HEIGHT = (105 * 100) / 68;

/** Abstand zweier Positionen in Zeichnungseinheiten (x und y gleich gewichtet). */
export function positionDistance(a: Pick<FormationPosition, 'x' | 'y'>, b: Pick<FormationPosition, 'x' | 'y'>): number {
  return Math.hypot(a.x - b.x, ((a.y - b.y) * FULL_HEIGHT) / 100);
}

/**
 * Freier Platz fuer einen neuen Spieler: der erste Punkt eines groben Rasters (von der Mitte nach aussen),
 * der von allen anderen Spielern genug Abstand hat. Ist alles besetzt, die Feldmitte.
 */
export function nextFreeSpot(positions: readonly FormationPosition[]): { x: number; y: number } {
  const center = { x: 50, y: 50 };
  const candidates: { x: number; y: number }[] = [];
  for (let y = 10; y <= 90; y += 8) for (let x = 10; x <= 90; x += 10) candidates.push({ x, y });
  candidates.sort((a, b) => positionDistance(a, center) - positionDistance(b, center));
  const free = candidates.find((candidate) => positions.every((position) => positionDistance(candidate, position) >= FORMATION_LIMITS.minDistance * 1.5));
  return free ?? center;
}

/** Eine neue Formation beginnt mit dem Torwart. */
export const NEW_FORMATION_POSITIONS: FormationPosition[] = [{ x: 50, y: 92, label: 'TW', role: 'GK' }];
